<template>
  <div class="ItemDetail" :class="{ active: isOpen }">
    <div class="ItemDetail--Header" @click="$emit('onCloseDetail', product)">
      <div class="ItemDetail--Title" v-if="product">{{ product.title }}</div>
      <div class="ArrowIcon" v-html="icons.arrowBottom"></div>
    </div>
    <div class="ItemDetail--Content" v-if="product">
      <img
        v-if="product.featuredImage"
        :src="product.featuredImage.url"
        :alt="product.featuredImage.altText"
      />
      
      <div class="ItemDetail--Description">{{ product.description }}</div>

      <!-- <img
        v-if="product.featuredImage"
        :src="product.featuredImage.url"
        :alt="product.featuredImage.altText"
      />
      
      <div class="ItemDetail--Info">
        <div class="ItemDetail--NoteTitle">{{ translations.format }}</div>
        <div class="ItemDetail--InfoItem" v-if="product.category">{{ product.category.name }}</div>
      </div>
      <div class="ItemDetail--Info">
        <div class="ItemDetail--NoteTitle">{{ translations.collection }}</div>
        <div class="ItemDetail--InfoItem">{{ getMetafield(product, 'collection') }}</div>
      </div>
      <div class="ItemDetail--Info">
        <div class="ItemDetail--NoteTitle">{{ translations.olfactive_family }}</div>
        <div class="ItemDetail--InfoItem">
          <template v-for="(n, i) in getMetafield(product, 'olfactive_Family')" :key="n">
            {{ n }}<span v-if="i < getMetafield(product, 'olfactive_Family').length - 1">, </span>
          </template>
        </div>
      </div>

      <img
        v-if="getMetafield(product, 'olfactoryNotes_image')"
        :src="getMetafield(product, 'olfactoryNotes_image').url"
        :alt="getMetafield(product, 'olfactoryNotes_image').altText"
      /> -->
      <div v-if="hasNotesMetafield()">
        <div class="ItemDetail--NotesTitle">{{ translations.olfactory_notes }}</div>
        <div class="ItemDetail--NotesContainer">
          <div class="ItemDetail--NoteContainer" v-for="note in notes" :key="note">
            <span class="ItemDetail--NoteTitle">{{ note }}</span>
            <div class="ItemDetail--NoteItem" v-for="n in getMetafield(product, `olfactoryNotes_${note}`)" :key="n">
              {{ n }}
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="ItemDetail--OlfactoryTitle">{{ getMetafield(product, 'editorial_Title') }}</div>

      <img
        v-if="getMetafield(product, 'editorialImage_Single')"
        :src="getMetafield(product, 'editorialImage_Single').url"
        :alt="getMetafield(product, 'editorialImage_Single').altText"
      />

      <div class="ItemDetail--NoteItem">{{ getMetafield(product, 'editorial_Description') }}</div>

      <div class="ItemDetail--Gallery">
        <div>
          <img
            v-if="getMetafield(product, 'editorialImage_Double')"
            :src="getMetafield(product, 'editorialImage_Double').url"
            :alt="getMetafield(product, 'editorialImage_Double').altText"
          />
        </div>
        <div>
          <img
            v-if="getMetafield(product, 'editorialImage_Double2')"
            :src="getMetafield(product, 'editorialImage_Double2').url"
            :alt="getMetafield(product, 'editorialImage_Double2').altText"
          />
        </div>
      </div> -->

      <button class="button button--primary" @click="$emit('onProductAdd', product)">
        {{ translations.add_to_set }}
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      icons: {},
      translations: {},
      notes: {},
      isOpen: {
        type: Boolean,
        default: false
      },
      product: {},
    },
    methods: {
      hasNotesMetafield() {
        for (const note of this.notes) {
          const metafield = this.getMetafield(this.product, `olfactoryNotes_${note}`);
          if (metafield && metafield.length > 0) {
            return true;
          }
        }
        return false;
      },
      getMetafield(product, key) {
        const metafields = product.metafields.filter(m => m != null);
        const metafield = metafields.find(m => m.key && m.key === key);
        if (metafield) {
          try {
            const value = JSON.parse(metafield.value);
            if (value.type === 'root') {
              return this.getRichText(value);
            } 
            if (Array.isArray(value)) {
              return value.map(x => x.split(',')).flat();
            }
            return value;
          } catch (error) {
            if (metafield.reference) {
              return metafield.reference.image;
            }
            return metafield.value;
          }
        }
        return undefined;
      },
      getRichText(metafield) {
        const paragraph = metafield.children.find(child => child.type === 'paragraph');
        if (paragraph) {
          const textNode = paragraph.children.find(child => child.type === 'text');
          if (textNode) {
            return textNode.value;
          }
        }
        return '';
      },
    }
  }
</script>
